const mutations = {
  SET_RESOURCES(state, payload) {
    state.reports = payload.resources.reports;
    state.aboutOurFunds = payload.resources.aboutOurFunds;
  }
};
const getters = {
  getReports: state => state.reports,
  getAboutOurFunds: state => state.aboutOurFunds
};

const state = {
  reports: null,
  aboutOurFunds: null
};

export default {
  state,
  getters,
  mutations
};

